import { lazy } from 'react';

const FAQ = lazy(() => import(/* webpackChunkName: "faq" */ './FAQ'));

const FAQDetail = lazy(() => import(/* webpackChunkName: "faq-detail" */ './FAQDetail'));

export { FAQ, FAQDetail };
